export const API_ROUTES = {
  GET_COMMON_ATTRIBUTE: '/get-common-attribute',
  GET_DROPDOWN_LIST: '/get-dropdown-option',
  GET_PRESIGNED_URL: 'presigned-url',
  GET_DISCOUNT_CATEGORY_LIST: '/discount-category-list',
  GET_DISCOUNT_CATEGORY_DETAIL: '/discount-category-detail',
  MANAGE_DISCOUNT_CATEGORY: '/manage-discount-category',
  MANAGE_CATEGORY_STATUS: '/manage-category-status',
  ASSIGN_DISCOUNT_CATEGORY: '/manage-assign-category-club',
  DISCOUNT_CATEGORY_DETAIL_STATUS_MANAGE: '/manage-category-detail-status',
  GET_COMMISSION_CATEGORY: '/get-commission-category-list',
  CREATE_COMMISSION_CATEGORY: '/manage-commission-category',
  GET_COMMISSION_CATEGORY_DETAIL: '/get-commission-category-list-detail',
  UPDATE_COMMISSION_CATEGORY_STATUS: '/update-commission-category-status',
  ASSIGN_COMMISSION: '/assign-commission-category',
  CHARGE_MANAGEMENT_LIST: '/charge-management-list',
  ASSIGN_CHARGE: '/assign-charge',
  GET_TIME_INTERVAL: 'get-time-interval',
  GET_CHARGE_DETAIL: '/charge-detail',
  GET_CHARGE_MANAGEMENT_DETAIL: '/charge-management-detail',
  GET_CURRENT_CHARGE: '/current-category',
  MANAGE_CHARGE: '/manage-charge',
  MANAGE_CHARGE_DETAIL: '/manage-charge-detail',
  CHARGE_MANAGEMENT_DETAIL_LIST: '/charge-management-detail-list',
  CHARGE_STATUS: '/charge-status',
  CHARGE_DETAIL_STATUS: '/charge-detail-status',
  GET_CUSTOMER_LIST: '/customer-list',
  GET_CUSTOMER_DETAIL: '/customer-detail',
  UPDATE_CUSTOMER_STATUS: '/update-customer-status',
  RESET_CUSTOMER_PASSWORD: '/reset-customer-password',
  MANAGE_CUSTOMER: '/manage-customer',
  GET_AFFILIATE_LIST: '/affiliate-list',
  GET_AFFILIATE_DETAIL: '/affiliate-detail',
  RESET_AFFILIATE_PASSWORD: '/reset-affiliate-password',
  UPDATE_AFFILIATE_STATUS: '/update-affiliate-status',
  UPDATE_AFFILIATE_DETAILS: '/manage-affiliate',
  GET_WITHDRAWAL_SETUP_LIST: '/withdrawal-setup-list',
  GET_WITHDRAWAL_DETAIL: '/withdrawal-setup-detail',
  MANAGE_WITHDRAWAL_SETUP: '/manage-withdrawal-setup',
  GET_DEFAULT_COMMISSION_TYPE: '/get-default-commission-type',
  COMMISSION_CATEGORY_DETAIL_LIST: '/commission-category-detail-list',
  DISCOUNT_CATEGORY_DETAIL_LIST: '/discount-category-detail-list',
  DISCOUNT_CATEGORY_DETAIL_MANAGE: '/discount-category-detail-manage',
  DELETE_COMMISSION_DETAIL: '/delete-commission-detail',
  MANAGE_COMMISSION_DETAIL: '/manage-commission-detail',
  GET_COMMISSION_CATEGORY_DETAIL_LIST_DETAIL: 'get-commission-category-detail-list-detail',
  GET_DISCOUNT_CATEGORY_DETAIL_LIST_DETAIL: 'get-discount-category-detail-list-detail',
  UPDATE_PLAN_STATUS: '/update-plan-status',
  UPDATE_PLAN_REQUEST: '/update-plan-request',
  UPDATE_PLAN_REQUEST_STATUS: '/approve-plan-request',
  GET_PLAN_LIST: '/get-plan-list',
  GET_PLAN_REQUEST: '/get-plan-request-list',
  GET_CLUB_PLAN_LIST: '/get-club-plan-list',
  GET_CLUB_PLAN_DETAIL: '/get-club-plan-detail',
  GET_ADMIN_PLAN_DETAIL: 'get-admin-club-plan-details',
  GET_STORE_OWNER_LIST: '/get-store-owner-list',
  GET_GROUP_LIST: '/get-group-list',
  GET_GROUP_SUMMARY: '/get-group-summary',
  GET_GROUP_DETAIL: '/get-group-detail',
  MANAGE_GROUP: '/manage-group',
  MANAGE_SUB_GROUP: '/manage-sub-group',
  ASSIGN_SUB_GROUP_CLUB: '/assign-sub-group-club',
  UPDATE_GROUP_STATUS: '/update-group-status',
  GET_SUB_GROUP_LIST: '/get-sub-group-list',
  GET_SUB_GROUP_DETAIL: '/get-sub-group-detail',
  MANAGE_SUB_GROUP_CLUB_STATUS: '/manage-sub-group-club-status',
  UPDATE_SUB_GROUP_STATUS: '/update-sub-group-status',
  GET_BASIC_STORE_LIST: '/get-basic-store-list',
  BLOCK_UNBLOCK_BASIC_STORE_INFO: '/block-unblock-basic-store-info',
  UPDATE_BASIC_STORE_INFO: '/update-basic-store-info',
  GET_BASIC_STORE_DETAIL: '/get-basic-store-detail',
  ADD_BASIC_STORE: '/add-basic-store',
  DELETE_BASIC_STORE_INFO: '/delete-basic-store-info',
  SWITCH_STORE_INFO: '/switch-store-info',
  GET_HOST_LIST: '/get-host-list',
  BLOCK_UNBLOCK_HOST: '/block-unblock-host',
  ADD_HOST_INFO: '/add-host-details',
  UPDATE_HOST_DETAILS: '/update-host-details',
  GET_HOST_DETAILS: '/get-host-details',
  GET_GALLERY: '/get-gallery',
  ADD_GALLERY: '/add-gallery',
  UPDATE_GALLERY: '/update-gallery',
  DELETE_GALLERY: '/delete-gallery',
  GET_PREMIUM_STORE_LIST: '/get-premium-store-list',
  ADD_PREMIUM_STORE: '/add-premium-info',
  GET_PREMIUM_STORE_DETAILS: '/get-premium-store-details',
  UPDATE_PREMIUM_STORE_INFO: '/update-premium-store-info',
  DELETE_PREMIUM_STORE_INFO: '/delete-premium-store-info',
  APPROVE_PREMIUM_STORE_INFORMATION: '/approve-premium-store-information',
  REJECT_PREMIUM_STORE_INFORMATION: '/reject-premium-store-info',
  BLOCK_UNBLOCK_PREMIUM_STORE_INFO: '/block-unblock-premium-store-info',
  RESET_PREMIUM_STORE_PASSWORD: '/reset-premium-store-password',
  ADD_CLUB_PLAN: '/add-club-plan',
  UPDATE_CLUB_PLAN: 'update-club-plan',
  UPDATE_CLUB_PLAN_STATUS: 'update-club-plan-status',
  UPDATE_ADMIN_PLAN: 'update-admin-club-plan-details',
  ADD_TAG_MANAGEMENT: '/add-tag-management',
  GET_ADMIN_STAFF_LIST: '/get-staff-list',
  ADD_ADMIN_STAFF: '/add-staff',
  DELETE_ADMIN_STAFF: '/delete-staff',
  EDIT_ADMIN_STAFF: '/update-staff',
  RESET_ADMIN_STAFF_PASSWORD: '/staff-reset-password',
  UPDATE_ADMIN_STAFF_STATUS: '/staff-update-status',
  GET_RESERVATION_LEDGER_LIST: '/get-reservation-ledger',
  GET_AFFILIATE_REFERRAL_REPORT: '/affiliate-referral-report',
  GET_REFERRAL_ANALYTICS: '/get-referral-analytics',
  GET_CUSTOMER_REFERRAL_REPORT: '/referral/customer-report',
  GET_AFFILIATE_REFERRAL_CUSTOMER_DETAILS: '/affiliate-referral-report/customer-details',
  GET_AFFILIATE_REFERRAL_AFFILIATE_DETAILS: '/affiliate-referral-report/affiliate-details',
  VERIFY_RESERVATION_OTP: '/verify-reservation-otp',
  GET_LOCATION_LIST: '/get-location-list',
  GET_LOCATION_DETAIL: '/get-location-detail',
  UPDATE_LOCATION_DETAIL: '/update-location-detail',
  UPDATE_LOCATION_STATUS: '/update-location-status',
  GET_SMS_LOG_LIST: '/sms-log',
  GET_EMAIL_LOG_LIST: '/email-log',
  MANAGE_LINE_DETAILS: '/manage-line-details',
  GET_LINE_DETAILS: '/get-line-details',
  GET_SUB_DOMAIN_DETAILS: '/sub-domain-details',
  MANAGE_SUB_DOMAIN: '/manage-subdomain',
  GET_INQUIRY: '/inquiry',
  GET_REVIEW_AND_RATINGS: '/review-ratings',
  GET_COMPLAINTS: '/complaints',
  GET_INQUIRY_DETAILS: '/get-inquiry-details',
  DELETE_USER_RATINGS: '/delete-user-ratings',
  GET_RETINGS_PREVIEW: '/ratings-preview',
  GET_EDITORS_PICK: '/recommendations/editor-picks',
  ADD_EDITORS_PICK: '/recommendations/editor-picks/create',
  UPDATE_EDITORS_PICK: '/recommendations/editor-picks/update',
  DELETE_EDITORS_PICK: '/recommendations/editor-picks/delete',
  GET_POINTS_LIST: '/point-management/list',
  GET_POINT_CATEGORY_DETAILS: '/point-management/details',
  CREATE_POINT_CATEGORY: '/point-management/create',
  UPDATE_POINT_CATEGORY: '/point-management/update',
  ASSIGN_POINT_CATEGORY: '/point-management/assign',
  UPDATE_POINT_CATEGORY_STATUS: '/point-management/status-update',
  DELETE_POINT_CATEGORY: '/point-management/delete',
  GET_POINT_SLABS: '/point-management/slab',
  GET_POINT_SLAB_DETAILS: '/point-management/slab/details',
  CREATE_POINT_SLAB: '/point-management/slab/create',
  UPDATE_POINT_SLAB: '/point-management/slab/update',
  UPDATE_POINT_SLAB_STATUS: '/point-management/slab/status-update',
  DELETE_POINT_SLAB: '/point-management/slab/delete',
  GET_PROMOTIONAL_BANNER_LIST: '/get-promotional-banner',
  GET_PROMOTIONAL_BANNER_DETAIL: '/get-promotional-banner-detail',
  ADD_PROMOTIONAL_BANNER: '/add-promotional-banner',
  UPDATE_PROMOTIONAL_BANNER: '/update-promotional-banner',
  UPDATE_PROMOTIONAL_BANNER_STATUS: '/update-promotional-banner-status',
  DELETE_PROMOTIONAL_BANNER: '/delete-promotional-banner',
  UPDATE_USER_PROFILE: '/account/user-profile/update',
  GET_USER_PROFILE: '/account/user-profile/get',
  GET_CHARGE_SUBCATEGORY: '/charge/sub-category',
  GET_STATIC_DATA_TYPE: '/get-static-data-type',
  GET_STATIC_DATA_TYPE_DETAIL: '/static-data-type-viewdetail',
  CREATE_STATIC_DATA_TYPE: '/add-static-data-type',
  UPDATE_STATIC_DATA_TYPE: '/update-static-data-type',
  DELETE_STATIC_DATA_TYPE: '/delete-static-data-type',
  GET_STATIC_DATA_TYPE_LABEL: '/get-static-data-label',
  GET_STATIC_DATA_TYPE_LABEL_DETAIL: '/get-static-data-label-detail',
  CREATE_STATIC_DATA_TYPE_LABEL: '/add-static-data-label',
  UPDATE_STATIC_DATA_TYPE_LABEL: '/update-static-data-label',
  DELETE_STATIC_DATA_TYPE_LABEL: '/delete-static-data-label',
  GET_CHARGE_SUBCATEGORY_DETAIL: '/charge/sub-category/detail',
  ADD_CHARGE_SUBCATEGORY: '/charge/sub-category',
  UPDATE_CHARGE_SUBCATEGORY: '/charge/sub-category/update',
  UPDATE_CHARGE_SUBCATEGORY_STATUS: '/charge/sub-category/status',
  MANAGE_REFERRAL_VALIDITY: '/manage-referral-validity',
  GET_REFERRAL_LIST: '/get-referral-list',
  GET_POINT_SETTING_LIST: '/get-point-setting-list',
  GET_POINT_SETTING_DETAIL: '/get-point-setting-details',
  MANAGE_POINT_SETTING: '/manage-point-setting',
  MANAGE_POINT_SETTING_STATUS: '/manage-point-setting-status',
  GET_REFERRAL_STAGE_LIST: '/get-referral-stage-list',
  MANAGE_REFERRAL_STAGE_STATUS: '/manage-referral-stage-status',
  GET_REFERRAL_STAGE_DETAIL: '/get-referral-stage-detail',
  MANAGE_REFERRAL_STAGE: '/manage-referral-stage',
  GET_CUSTOMER_WITHDRAWAL_LIST: '/customer/withdrawal/list',
  GET_CUSTOMER_WITHDRAWAL_DETAIL: '/customer/withdrawal/detail',
  UPDATE_CUSTOMER_WITHDRAWAL_DETAIL: '/customer/withdrawal/manage',
  GET_CUSTOMER_PAYMENT_LIST: '/customer-payment/point-withdrawal/list',
  UPDATE_CUSTOMER_PAYMENT_LIST: '/customer-payment/point-withdrawal-action/manage',
  GET_BANK_INFORMATION: 'admin/bank-information',
  MANAGE_BANK_INFORMATION: 'admin/bank-information',
  GET_PAYMENT_OVERVIEW: '/payment-overview',
  GET_PAYMENT_OVERVIEW_ANALYTICS: '/payment-overview-analytics',
  GET_PAYMENT_OVERVIEW_RESERVATION_CHART: '/payment-overview-reservation-chart',
  GET_PAYMENT_SALES_BREAKDOWN: '/payment-sales-breakdown',
  GET_STORE_PAYMENT_LOGS: '/store/payment-logs',
  GET_STORE_PAYMENT_LOGS_DETAILS: '/store/payment-logs/details',
  GET_AFFILIATE_WITHDRAW_LOG: '/affiliate-withdraw-log',
  GET_AFFILIATE_WITHDRAW_LOG_DETAIL: '/affiliate-withdraw-log-detail',
  GET_MAIN_PAGE_GROUP: '/recommendations/main-page-group',
  CREATE_MAIN_PAGE_GROUP: '/recommendations/main-page-group/create',
  UPDATE_MAIN_PAGE_GROUP: '/recommendations/main-page-group/update',
  DELETE_MAIN_PAGE_GROUP: '/recommendations/main-page-group/delete',
  MAIN_PAGE_SHUFFLE: '/recommendations/main-page-shuffle',
  UPDATE_MAIN_PAGE_SHUFFLE: '/recommendations/main-page-shuffle/update',
  GET_MAIN_PAGE_STORE: '/recommendations/main-page-store',
  DELETE_MAIN_PAGE_STORE: '/recommendations/main-page-store/delete',
  CREATE_MAIN_PAGE_HOST: '/recommendations/main-page-host/create',
  GET_MAIN_PAGE_HOST: '/recommendations/main-page-host',
  DELETE_MAIN_PAGE_HOST: '/recommendations/main-page-host/delete',
  UPDATE_MAIN_PAGE_HOST: '/recommendations/main-page-host/update',
  GET_API_MESSAGE_LIST: '/api-message-list',
  GET_API_MESSAGE_DETAIL: '/api-message-detail',
  ADD_API_MESSAGE: '/add-api-message',
  UPDATE_API_MESSAGE: '/update-api-message',
};
